export * from './partial';
export * from './transcription-row.component';
